module.exports = __webpack_public_path__ + "static/media/Votingregistration.1004428b.png";